import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createRateAction } from '../../../redux/actions/ratesActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import RateForm from '../forms/RateForm';

const CreateRateModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createRateAction(data));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати оцінку вартості'}
      loading={loading}
      onClose={onModalClose}
      body={<RateForm readOnly={false} onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'rate-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateRateModal;
